import axios from 'axios'
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'

export const setAuthorizationHeader = token => {
  if (token !== null) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
  } else {
    delete axios.defaults.headers.common.Authorization
  }
}

export const setAuthToken = token => {
  setAuthorizationHeader(token)
  if (token === null) {
    return localStorage.removeItem('AUTH_TOKEN_KEY')
  }

  return localStorage.setItem('AUTH_TOKEN_KEY', token)
}

export const getAuthToken = () => (
  localStorage.getItem('AUTH_TOKEN_KEY')
)

export const checkTokenValidity = token => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(Buffer.from(base64, 'base64').toString('ascii').split('').map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
    .join(''))
  const user = JSON.parse(jsonPayload)
  if (user.exp < Date.now() / 1000) {
    // token expired
    return true
  }
  return false
}

export const checkTokenExpiry = token => {
  if (Date.now() >= jwt_decode(token) * 1000) {
    // token expired
    return true
  }
  return false
}
